import axios from "../axios";
import React, { useState, useEffect } from "react";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer"
const base_url = "https://image.tmdb.org/t/p/original";


function Row({ titles, fetchUrl, isLargeRow }) {
	const [movies, setMovies] = useState([]);
	const [trailerUrl, setTrailerUrl] = useState("");

	useEffect(() => {
		async function fetchData() {
			const request = await axios.get(fetchUrl);
			setMovies(request.data.results);
			return request;
		}
		fetchData();
	}, [fetchUrl]);

	const opts = {
		height : "390",
		width : "100%",
		playerVars : {
			autoplay : 1,
		},
	};

	const handleClick = (movie) => {
		if (trailerUrl) {
			setTrailerUrl('');
		}
		else {
			movieTrailer(movie?.name || movie?.title || "").then(url => {
				const urlPrams = new URLSearchParams(new URL(url).search);
				setTrailerUrl(urlPrams.get('v'));
			}).catch(error => console.log(error.message));
		}
	};
	
	return (
		<div className="row">
			<h2 className="row_title">{titles}</h2>
			<div className="row_posters">
				{movies.map((movie) => (
					<img
						key={movie.id}
						onClick={() => handleClick(movie)}
						className={`row_poster ${isLargeRow && "row_posterLarge"} `}
						src={`${base_url}${isLargeRow ? movie.poster_path : movie.backdrop_path}`}
						alt={movie.name || movie.title}
					/>
				))}
			</div>
			{ trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
		</div>
	);
}

export default Row;
